var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransactionFunnelIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#85E6C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 28.75C21.1819 28.75 22.3522 28.5172 23.4442 28.0649C24.5361 27.6126 25.5282 26.9497 26.364 26.114C27.1997 25.2782 27.8626 24.2861 28.3149 23.1942C28.7672 22.1022 29 20.9319 29 19.75C29 18.5681 28.7672 17.3978 28.3149 16.3058C27.8626 15.2139 27.1997 14.2218 26.364 13.386C25.5282 12.5503 24.5361 11.8874 23.4442 11.4351C22.3522 10.9828 21.1819 10.75 20 10.75C17.6131 10.75 15.3239 11.6982 13.636 13.386C11.9482 15.0739 11 17.3631 11 19.75C11 22.1369 11.9482 24.4261 13.636 26.114C15.3239 27.8018 17.6131 28.75 20 28.75ZM19.768 23.39L24.768 17.39L23.232 16.11L18.932 21.269L16.707 19.043L15.293 20.457L18.293 23.457L19.067 24.231L19.768 23.39Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionFunnelIcon3);
export default __webpack_public_path__ + "static/media/TransactionFunnelIcon3.214fe7bda048aa35429361e7f2d6088f.svg";
export { ForwardRef as ReactComponent };